module.exports = __webpack_public_path__ + "static/img/down2.60ee15e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/down2.png
// module id = CCmQ
// module chunks = 1